"use strict";

export function init() {

    const eventSticky = document.querySelector('.event-sticky');

    if (eventSticky) {
        const navLinks = Array.from(document.querySelectorAll('.event-nav__link'));

        const sections = document.querySelectorAll('section');
        const sectionsFilter = Array.from(sections).filter(section => section.id);

        window.addEventListener('scroll', function() {
            const eventHeader = document.querySelector('.event-header');
            let rect = null;
            rect = eventHeader.getBoundingClientRect();

            const footer = document.querySelector('.global-footer');
            var footerVisible = false;
            if (footer) {
                const fRect = footer.getBoundingClientRect();
                footerVisible = fRect.top <= window.innerHeight && fRect.bottom >= 0;
            }

            if (rect.bottom <= window.innerHeight / 2 && !footerVisible) {
                eventSticky.classList.add('show');
            } else {
                eventSticky.classList.remove('show');
            }
        }, { passive: true });

        document.addEventListener('click', function(e){
            const link = e.target;

            if (link.classList.contains('event-nav__link')){
                const id = link.getAttribute('href').slice(1);
                const block = document.getElementById(id);

                if (block) {
                    e.preventDefault();
                    block.scrollIntoView({
                        behavior: 'smooth',
                        block: 'start'
                    });
                }
            }
        });


        // Scroll for event nav links
        if (window.location.hash) {
            const targetElement = document.querySelector(window.location.hash);
            if (targetElement != null) {
                let targetPosition;
                
                targetPosition = targetElement.getBoundingClientRect().top;

                window.scrollTo({
                    top: targetPosition,
                    behavior: 'smooth'
                });
            }
        }

        // Active state for nav links
        const getSwiper = () => document.querySelector('.event-nav__nav')?.swiper;

        const setActiveLink = target => {
            navLinks.forEach(link => link.classList.remove('active'));
            target.classList.add('active');

            const swiper = getSwiper();
            const slideEl = target.closest('.swiper-slide');

            if (swiper && slideEl) {
                const slides = Array.from(swiper.slides);
                const index = slides.indexOf(slideEl);
                if (index !== -1) {
                    swiper.slideTo(index);
                }
            } else {
                target.scrollIntoView({
                    behavior: 'smooth',
                    block: 'nearest',
                    inline: 'center'
                });
            }
        };

        if (navLinks.length) {
            navLinks.forEach(link => {
                link.addEventListener('click', e => {
                    e.preventDefault();

                    const href = link.getAttribute('href') || '';
                    const targetId = href.split('#')[1];
                    const targetElement = document.getElementById(targetId);
                    if (!targetElement) return;

                    const targetPosition = targetElement.getBoundingClientRect().top;

                    window.scrollTo({
                        top: targetPosition,
                        behavior: 'smooth'
                    });

                    setActiveLink(link);
                });
            });
        }

        const updateActiveLinkOnScroll = () => {
            let currentSection = '';

            sectionsFilter.forEach(section => {
                const sectionTop = section.offsetTop;
                const sectionBottom = sectionTop + section.offsetHeight;
                const viewportMiddle = window.scrollY + window.innerHeight / 2;

                if (viewportMiddle >= sectionTop && viewportMiddle < sectionBottom) {
                    currentSection = section.getAttribute('id');
                }
            });

            if (currentSection) {
                const activeLink = navLinks.find(link => {
                    const href = link.getAttribute('href') || '';
                    const id = href.includes('#') ? href.split('#')[1] : null;
                    return id === currentSection;
                });

                if (activeLink && !activeLink.classList.contains('active')) {
                    setActiveLink(activeLink);
                }
            }
        };

        window.addEventListener('scroll', updateActiveLinkOnScroll);
        window.addEventListener('resize', () => {
            updateActiveLinkOnScroll();
        });

        updateActiveLinkOnScroll();
    }

}